// extracted by mini-css-extract-plugin
export default {"item":"rf9vKfgsTqGJWhyhd0jg"};